import { Box, Stack, Typography } from '@mui/material';
import PdfIcon from '@mui/icons-material/PictureAsPdf';
import LockIcon from '@mui/icons-material/Https';
import { Attachment } from './AttachmentsTab';

interface Props {
  attachment: Attachment;
  isAdded: boolean;
  isRemoved?: boolean;
}

function AttachmentItem({ attachment, isAdded, isRemoved }: Props) {
  return (
    <Box
      sx={{
        width: 156,
        height: 156,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      {attachment?.mimeType === 'application/pdf' ? (
        <PdfIcon />
      ) : (
        <Box
          component="img"
          src={
            attachment.current.thumbnailUrl ??
            attachment.current.optimisedUrl ??
            attachment.current.uploadedUrl
          }
          alt={attachment.current.title}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            ...(isAdded && {
              border: '2px solid',
              borderColor: 'success.main',
            }),
            ...(isRemoved && {
              border: '2px solid',
              borderColor: 'error.main',
            }),
          }}
        />
      )}

      {!attachment.current.isPublic && (
        <Box
          sx={(theme) => ({
            width: '26px',
            height: '26px',
            backgroundColor: '#fff',
            borderRadius: '50%',
            color: theme.palette.primary.main,
            top: 6,
            left: 6,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          })}>
          <LockIcon sx={{ fontSize: 14 }} />
        </Box>
      )}

      <Stack
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.64)',
          color: '#fff',
          px: 1,
          py: 1.3,
          boxSizing: 'border-box',
        }}>
        <Typography
          variant="subtitle2"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
          {attachment.current.title}
        </Typography>
      </Stack>
    </Box>
  );
}

export default AttachmentItem;
